import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { STORAGE_KEYS as s } from "./storage-manager.js";
import u from "./subscription-manager.js";
import ni from "../models/server-config.js";
import c from "../common/event-logger.js";
import { EventTypes as m } from "../../shared-lib/index.js";
var Vt = /*#__PURE__*/function () {
  function Vt(t) {
    _classCallCheck(this, Vt);
    this.j = t, this.j = t, this.tl = new u(), this.il = new u(), this.el = new u(), this.sl = new u(), this.rl = null, this.ul = null;
  }
  _createClass(Vt, [{
    key: "al",
    value: function al() {
      if (null == this.ul) {
        var t = this.j.lt(s.ct.hl);
        this.ul = null != t ? ni.qn(t) : new ni();
      }
      return this.ul;
    }
  }, {
    key: "Ft",
    value: function Ft() {
      return this.al().ol;
    }
  }, {
    key: "cl",
    value: function cl(t) {
      var _this = this;
      var i, e;
      if (null != t && null != t.config) {
        var n = t.config;
        if (n.time > this.al().ol) {
          var _t = function _t(t) {
              return null == t ? _this.al().ml : t;
            },
            r = new ni(n.time, n.events_blacklist, n.attributes_blacklist, n.purchases_blacklist, n.messaging_session_timeout, n.vapid_public_key, n.content_cards, n.feature_flags, _t(n.global_request_rate_limit), n.banners);
          var l = !1;
          null != r.dl && this.Wn() !== r.dl && (l = !0);
          var _u = !1;
          null != r.gl.enabled && this.gi() !== r.gl.enabled && (_u = !0);
          var a = !1;
          null != r.he.enabled && this.Re() !== r.he.enabled && (a = !0);
          var h = !1;
          null != (null === (i = r.banners) || void 0 === i ? void 0 : i.enabled) && this.Dt() !== (null === (e = r.banners) || void 0 === e ? void 0 : e.enabled) && (h = !0), this.ul = r, this.j.ft(s.ct.hl, r.dt()), l && this.tl.L(), _u && this.il.L(), a && this.el.L(), h && this.sl.L();
        }
      }
    }
  }, {
    key: "_n",
    value: function _n(t) {
      var i = this.tl.wt(t);
      return this.rl && this.tl.removeSubscription(this.rl), this.rl = i, i;
    }
  }, {
    key: "vi",
    value: function vi(t) {
      return this.il.wt(t);
    }
  }, {
    key: "Ue",
    value: function Ue(t) {
      return this.el.wt(t);
    }
  }, {
    key: "P",
    value: function P(t) {
      return this.sl.wt(t);
    }
  }, {
    key: "ge",
    value: function ge(t) {
      return -1 !== this.al().bl.indexOf(t);
    }
  }, {
    key: "hu",
    value: function hu(t) {
      return -1 !== this.al().fl.indexOf(t);
    }
  }, {
    key: "Dr",
    value: function Dr(t) {
      return -1 !== this.al().vl.indexOf(t);
    }
  }, {
    key: "Rl",
    value: function Rl() {
      return this.al().Cl;
    }
  }, {
    key: "Wn",
    value: function Wn() {
      return this.al().dl;
    }
  }, {
    key: "gi",
    value: function gi() {
      return this.al().gl.enabled || !1;
    }
  }, {
    key: "El",
    value: function El() {
      var t = this.al().ml;
      return !(!t || null == t.enabled) && t.enabled;
    }
  }, {
    key: "Ju",
    value: function Ju() {
      if (!this.El()) return -1;
      var t = this.al().ml;
      return null == t.capacity || t.capacity < 10 ? -1 : t.capacity;
    }
  }, {
    key: "Qu",
    value: function Qu() {
      if (!this.El()) return -1;
      var t = this.al().ml;
      return null == t.refill_rate || t.refill_rate <= 0 ? -1 : t.refill_rate;
    }
  }, {
    key: "wl",
    value: function wl(t) {
      var i = this.al().ml.endpoint_overrides;
      return null == i ? null : i[t];
    }
  }, {
    key: "Vu",
    value: function Vu(t) {
      var i = this.wl(t);
      return null == i || isNaN(i.capacity) || i.capacity <= 0 ? -1 : i.capacity;
    }
  }, {
    key: "Zu",
    value: function Zu(t) {
      var i = this.wl(t);
      return null == i || isNaN(i.refill_rate) || i.refill_rate <= 0 ? -1 : i.refill_rate;
    }
  }, {
    key: "Re",
    value: function Re() {
      return this.al().he.enabled && null == this.ke() ? (c.rt(m.pu, {
        e: "Missing feature flag refresh_rate_limit."
      }), !1) : this.al().he.enabled || !1;
    }
  }, {
    key: "ke",
    value: function ke() {
      return this.al().he.refresh_rate_limit;
    }
  }, {
    key: "Dt",
    value: function Dt() {
      var t;
      return (null === (t = this.al().banners) || void 0 === t ? void 0 : t.enabled) || null;
    }
  }, {
    key: "te",
    value: function te() {
      var t;
      return (null === (t = this.al().banners) || void 0 === t ? void 0 : t.max_placements) || 0;
    }
  }]);
  return Vt;
}();
export { Vt as default };